export default {"src":"/_next/static/image/public/images/ic_guest_order.ef4de14684dc042b17e1648164f348b7.svg","height":143,"width":143};